// extracted by mini-css-extract-plugin
export default {"fit":"App_fit__Wi-qM","mainContentFlex":"App_mainContentFlex__75Sj7","rightColumn":"App_rightColumn__dHCuf"};